import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { callApi } from '../../utils/callApi';
import { ApiEvents } from '../../utils/SocketEvents';
import { CheckUser, ShowUsers, TypeChekUserR, TypeShowUsersR, UsersActions } from './actions';
import ActionTypes, { TUsersState } from './types';
import { sendStat } from '../../hooks/sendStat';

function* checkUserWorker(action: ReturnType<typeof CheckUser.request>): Generator {
  const { data, callBack } = action.payload as TypeChekUserR;
  let success = true;
  try {
    setTimeout(sendStat, 500);
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.checks,
    })) as TUsersState['user'];
    yield put(UsersActions.setUser(resp));
  } catch (e) {
    success = false;
    yield put(CheckUser.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* showUsersWorker(action: ReturnType<typeof ShowUsers.request>): Generator {
  const { data, callBack } = action.payload as TypeShowUsersR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.showUsers,
    })) as TUsersState['users'];
    yield put(UsersActions.setUsers(resp));
  } catch (e) {
    success = false;
    yield put(UsersActions.setError(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchUserFetchRequest() {
  yield takeEvery(ActionTypes.CHECK_USER_R, checkUserWorker);
  yield takeEvery(ActionTypes.SHOW_USERS_R, showUsersWorker);
}
export default function* usersSaga() {
  yield all([fork(watchUserFetchRequest)]);
}
